import { render } from "./HealBox.vue?vue&type=template&id=02f48f80"
import script from "./HealBox.vue?vue&type=script&lang=js"
export * from "./HealBox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__